// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables for Instec */\n[data-v-207312e7]:export {\n  menuBg: #0F4C81;\n  menuText: #ffffff;\n  menuActiveText: #0F4C81;\n  menuActiveBg: #ffffff;\n}\n\n/* Mixins */\n.edit-input[data-v-207312e7] {\n  padding-right: 100px;\n}\n.cancel-btn[data-v-207312e7] {\n  position: absolute;\n  right: 15px;\n  top: 10px;\n}", ""]);
// Exports
module.exports = exports;
